<div class="zn-step-content-sections">
  <div class="zn-step-content-section zn-step-content-section--selected stand-division-maintenance-section">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
          <h5>{{ (localizationKeyPrefix + '.Form.Title') | abpLocalization }} <zn-pill [label]="resultingStandChip()"></zn-pill></h5>
          <p>{{ (localizationKeyPrefix + '.Form.Description') | abpLocalization }}</p>
        </div>
        <div class="zn-summary-container">
          <div class="zn-summary-item">
            <p class="title">{{ 'Geographic::Entity.Cycle' | abpLocalization }}</p>
            <div class="subtitle">
              <p>{{ displayValue(cycle()) }}
              @if (isLastCycle()) {
                - {{'Geographic::Entity.Cycle.IsLastCycle' | abpLocalization}}
              }
              </p>
            </div>
          </div>
          <div class="zn-summary-item">
            <p class="title">{{ 'Geographic::Entity.Rotation' | abpLocalization }}</p>
            <div class="subtitle">
              <p>{{ displayValue(rotation()) }}
              @if (isLastRotation()) {
                 - {{'Geographic::Entity.Rotation.IsLastRotation' | abpLocalization}}
              }
              </p>
            </div>
          </div>
          <div class="zn-summary-item">
            <p class="title">{{ (localizationKeyPrefix + '.Summary.CurrentArea') | abpLocalization }}</p>
            <p class="subtitle">{{ formatArea(currentArea()) }}</p>
          </div>
          <div class="zn-summary-item">
            <p class="title">{{ (localizationKeyPrefix + '.Summary.Variation') | abpLocalization }}</p>
            <p class="subtitle">{{ formatSignedArea(areaDelta()) }}</p>
          </div>
          <div class="zn-summary-item">
            <p class="title">{{ (localizationKeyPrefix + '.Summary.AdjustedArea') | abpLocalization }}</p>
            <p class="subtitle"><zn-pill [label]="formatArea(adjustedArea())"></zn-pill></p>
          </div>
        </div>
      </div>
      <hr class="zn-separator" />
    </div>
    <div class="zn-step-content-section-body">
      <form class="zn-form" [formGroup]="form">
        <div class="row">
          <div class="col-4">
            <div class="form-control-container">
              <label class="form-label" for="standFusionMaintenancePeriod">
                {{ 'LanguageService::Stand.MaintenancePeriod' | abpLocalization }}
                <span class="form-label-required">*</span>
              </label>
              <zn-single-select
                id="standFusionMaintenancePeriod"
                [options]="periodOptions()"
                [optionsLoader]="loadPeriod"
                [showSearch]="true"
                [placeholder]="(localizationKeyPrefix + '.SelectPlaceholder') | abpLocalization"
                formControlName="period"
                (selectedChange)="onPeriodChange($event)"
                [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
                [localizationResource]="localizationResource"
                [openUp]="false"
              ></zn-single-select>
              @if (fieldInvalid('period')) {
                <small class="invalid-feedback d-block">
                  {{ `${localizationResource}::DefaultErrorRequired` | abpLocalization }}
                </small>
              }
            </div>
          </div>
          <div class="col-4">
            <div class="form-control-container">
              <label class="form-label" for="standFusionMaintenanceReason">
                {{ 'LanguageService::Stand.MaintenanceReason' | abpLocalization }}
                <span class="form-label-required">*</span>
              </label>
              <zn-single-select
                id="standFusionMaintenanceReason"
                [options]="reasonOptions()"
                [optionsLoader]="loadReason"
                [showSearch]="true"
                [placeholder]="(localizationKeyPrefix + '.SelectPlaceholder') | abpLocalization"
                formControlName="reason"
                (selectedChange)="onReasonChange($event)"
                [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
                [localizationResource]="localizationResource"
                [openUp]="false"
              ></zn-single-select>
              @if (fieldInvalid('reason')) {
                <small class="invalid-feedback d-block">
                  {{ `${localizationResource}::DefaultErrorRequired` | abpLocalization }}
                </small>
              }
            </div>
          </div>
          <div class="col-4">
            <div class="form-control-container">
              <label class="form-label" for="standFusionMaintenanceAdjustmentType">
                {{ 'LanguageService::Stand.AdjustmentType' | abpLocalization }}
                <span class="form-label-required">*</span>
              </label>
              <zn-single-select
                id="standFusionMaintenanceAdjustmentType"
                [options]="adjustmentTypeOptions()"
                [optionsLoader]="loadAdjustmentTypes"
                [showSearch]="true"
                [placeholder]="(localizationKeyPrefix + '.SelectPlaceholder') | abpLocalization"
                formControlName="adjustmentType"
                (selectedChange)="onAdjustmentTypeChange($event)"
                [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
                [localizationResource]="localizationResource"
                [openUp]="false"
              ></zn-single-select>
              @if (fieldInvalid('adjustmentType')) {
                <small class="invalid-feedback d-block">
                  {{ `${localizationResource}::DefaultErrorRequired` | abpLocalization }}
                </small>
              }
            </div>
          </div>
          <div class="col-8">
            <div class="form-control-container">
              <label class="form-label" for="standFusionMaintenanceDetails">
                {{ 'LanguageService::StandAreaMaintenance.Notes' | abpLocalization }}
              </label>
              <input
                id="standFusionMaintenanceDetails"
                class="form-control"
                type="text"
                formControlName="details"
                [placeholder]="`${localizationResource}::EnterText` | abpLocalization"
              />
            </div>
          </div>
          <div class="col-4">
            <div class="form-control-container">
              <label class="form-label form-check-label" for="standFusionMaintenanceUpdated">
                {{ `${localizationResource}::Stand.UpdatedArea` | abpLocalization }}
                <span class="form-label-required">*</span>
              </label>
              <div class="form-check-inner-container order-first">
                <input
                  id="standFusionMaintenanceUpdated"
                  class="form-check-input check-lg"
                  type="checkbox"
                  formControlName="isAreaUpdated"
                />
              </div>
              @if (fieldInvalid('isAreaUpdated')) {
                <small class="invalid-feedback d-block">
                  {{ `${localizationResource}::DefaultErrorRequired` | abpLocalization }}
                </small>
              }
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
